export const view = {
    methods: {
        selectFranchise: function () {
            var _self = this;
            if (this.selectedFranchise != null) {
                var franchise = this.selectedFranchise;
                _self.$franchiseID = franchise.id;
                _self.$franchiseName = franchise.name;
                _self.$franchiseUrlFriendlyOrderName = franchise.urlFriendlyOrderName;
                _self.$franchiseLogoUrl = franchise.franchiseLogoURL;
                _self.$franchiseBannerUrl = franchise.bannerImageURL;
                _self.$franchiseAccentColor = franchise.accentColor;

                _self.initOoApi(_self.$franchiseID);
                _self.initPayApi(_self.$franchiseID);

                this.$router.push({ path: 'Branch', query: { franchise: franchise.urlFriendlyOrderName }});
            }
        }
    }
}